import { EMPTY_VALUE, PARAM_TYPE_NUMBER } from "constant/application";
import { PropFormikField } from "constant/prop-types";
import PropTypes from "prop-types";
import React from "react";
import { FormControl } from "react-bootstrap";

function NumberField(props) {
  const { field, handleChange, isRequired, readOnly } = props;

  // Number(null) and Number('') will return 0 so we must use parseFloat
  const fieldValue = isNaN(parseFloat(field.value)) ? "" : String(field.value);
  const onChange = (e) => {
    let nextValue = parseFloat(e.target.value);
    nextValue = isNaN(nextValue) ? EMPTY_VALUE[PARAM_TYPE_NUMBER] : nextValue;

    handleChange(nextValue);
  };

  return (
    <FormControl
      type="number"
      disabled={readOnly}
      name={field.name}
      onChange={onChange}
      required={isRequired}
      value={fieldValue}
    />
  );
}

NumberField.propTypes = {
  field: PropFormikField.isRequired,
  handleChange: PropTypes.func.isRequired,
  isRequired: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
};

export { NumberField };
